import { render, staticRenderFns } from "./my-social-share-popup.vue?vue&type=template&id=22040b8b&scoped=true&"
import script from "./my-social-share-popup.vue?vue&type=script&lang=js&"
export * from "./my-social-share-popup.vue?vue&type=script&lang=js&"
import style0 from "./my-social-share-popup.vue?vue&type=style&index=0&id=22040b8b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22040b8b",
  null
  
)

export default component.exports